<template>
    <div>
        <v-row class="mt-1">
            <v-col v-for="(com, index) in companies" :key="index" cols="2">
                <v-card>
                    <v-card-title class="d-flex flex-column justify-center">
                        <v-icon> mdi-home-city-outline </v-icon>
                        <h4 >
                            {{ com.name }} 
                        </h4>
                    </v-card-title>
                    <!-- 
                    <v-card-text>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium adipisci tenetur provident architecto, consequatur laboriosam temporibus eum fuga aspernatur ducimus qui, autem aliquam amet dolorum beatae in excepturi illo omnis? 
                    </v-card-text> -->
                </v-card>

            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    data () {
        return {
            companies: [
                {
                    name: 'Cairo'
                },
                {
                    name: 'Cairo'
                },
                {
                    name: 'Cairo'
                },
                {
                    name: 'Cairo'
                },
                {
                    name: 'Cairo'
                },
                {
                    name: 'Cairo'
                }
            ]
        }
    }
}
</script>
